import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import styles from '../../../styles/profile.module.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { getProfileList, getInfoEmployee } from '../../../actions/myFile/profile';
import { toPhone, toPostalCode } from '../../../utils';
import { withNamespaces } from 'react-i18next';
import { formatDate } from '../../../utils';
import * as storage from '../../../utils/storage'
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Fab from '@material-ui/core/Fab';
import { isIOS } from '../../../utils';
import EditProfile from './EditProfile';
import EditIcon from '@material-ui/icons/Edit';
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { EmployeeCode } from '@utils/users';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faCalendar } from "@fortawesome/pro-duotone-svg-icons";
import { IsEnglish } from '@utils/language';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';

const useStyles = makeStyles((theme) => ({
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "160px"
        },
        textAlign: 'left',
        float: 'left',
        border: '1px solid red',
    },
    secondCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "65px"
        },
        float: 'left'
    },
    rootProfile: {
        overflow: 'auto',
        padding: '15px'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divButtons: {
        textAlign: 'center',
        marginBottom: '10px'
    },
    rootTable: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& td:first-child': {
            width: '30%',
            '@media (max-width: 600px)': {
                width: '45%'
            }
        },
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bolder',
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

function ProfileList(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [dataEmployee, setDataEmployee] = useState([]);
    const [open, setOpen] = useState(false);
    const [isPending, setIsPending] = useState(props.isPending || false);
    const [isiOS, setIsiOS] = useState(isIOS());
    const [isDisplaySeniorityDate, setIsDisplaySeniorityDate] = useState(false);
    const [isDisplayHiringDate, setIsDisplayHiringDate] = useState(false);
    const [isDisplayFirstDate, setIsDisplayFirstDate] = useState(false);
    const [isDisplayLastDate, setIsDisplayLastDate] = useState(false);
    const [isDisplayInactiveDate, setIsDisplayInactiveDate] = useState(false);
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        loadProfileList();
        resize();
        setIsDisplaySeniorityDate(storage.getDisplaySeniorityDate());
        setIsDisplayHiringDate(storage.getDisplayHiringDate());
        setIsDisplayFirstDate(storage.getDisplayFirstDate());
        setIsDisplayLastDate(storage.getDisplayLastDate());
        setIsDisplayInactiveDate(storage.getDisplayInactiveDate());
    }, []);

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = 90;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divProfile');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 0);
    }

    const loadProfileList = () => {
        setIsActive(true);
        getProfileList().then(response => {
            response.personalPhone = toPhone(response.personalPhone);
            response.personalCellphone = toPhone(response.personalCellphone);
            response.phoneOffice = toPhone(response.phoneOffice);
            response.corporateCellphone = toPhone(response.corporateCellphone);
            response.pager = toPhone(response.pager);
            response.postalCode = toPostalCode(response.postalCode);
            response.language = response.language === 'F' ? i18next.t('Language:french') : i18next.t('Language:english');

            setIsPending(response.isPending);

            setData(response);
            setIsActive(false);
        });
    }

    const loadEmployeeInfo = () => {
        setIsActive(true);
        getInfoEmployee().then(response => {
            setDataEmployee(response.dataEmployee);
            setIsActive(false);
        });
    }

    const handleReload = () => {
        loadProfileList();
    }

    const handleEdit = () => {
        if (storage.getIsProfileConsultationMode()) {
            return;
        }

        loadEmployeeInfo();
        setOpen(true);
    }

    const handleCloseEdit = () => {
        setOpen(false);
        resize();
    }

    const getInitials = () => {

        const userName = storage.getUserName();
        return userName
            .split(' ')
            .map(word => word[0].toUpperCase())
            .join('');;
    }

    return (
        <LoadingOverlay active={isActive} spinner={<BeatLoader />} text={i18next.t('profile:list.loading')}>
            <div>
                <div id="divProfile" className={styles.konekCard}>
                    <React.Fragment>
                        <ListItem button className="listItem">
                            <ListItemText disableTypography={true} primary={
                                <React.Fragment>
                                    <div className={styles.employeeCard + ' ' + ((data.statusDescriptionFrench != null || data.currentEmploymentStatusDescriptionEnglish != null) ? styles.employeeMargin : '')}>
                                        {(data.statusDescriptionFrench != null || data.currentEmploymentStatusDescriptionEnglish != null) &&
                                            <div className={styles.profileInfoStatus}>
                                                {data.statusDescriptionFrench != null &&
                                                    <span className={styles.statusIndicator + ' ' + styles.status}>{IsEnglish() ? data.statusDescriptionEnglish : data.statusDescriptionFrench}</span>
                                                }
                                                {data.statusDescriptionFrench != null &&
                                                    <span className={styles.statusIndicator + ' ' + styles.employmentStatus}>{IsEnglish() ? data.currentEmploymentStatusDescriptionEnglish : data.currentEmploymentStatusDescriptionFrench}</span>
                                                }
                                            </div>
                                        }
                                        <div className={styles.profileInfo}>
                                            <div className={styles.profilePhoto}>
                                                <div>
                                                    {data.photo != null &&
                                                        <img className={styles.profileBadge} src={`data:image/jpeg;base64,${data.photo}`} alt="Photo" />    
                                                    }

                                                    {data.photo == null &&
                                                        <div className={styles.profileBadge}>{getInitials()}</div>    
                                                    }
                                                </div>
                                            </div>

                                            <div>
                                                <div className={styles.profileName}>{storage.getUserName()}</div>
                                                <div className={styles.profileCode}>Code : {EmployeeCode()}</div>
                                                {data.defaultJobTitleDescriptionFrench != null &&
                                                    <div className={styles.profileCode}>{IsEnglish() ? data.defaultJobTitleDescriptionEnglish : data.defaultJobTitleDescriptionFrench}</div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                </React.Fragment>
                            } />
                        </ListItem>
                    </React.Fragment>

                    <React.Fragment>
                        <ListItem button className="listItem" onClick={handleEdit}>
                            <ListItemText disableTypography={true} primary={
                                <React.Fragment>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div className={styles.coordinateTitle}>
                                            <div style={{ fontSize: "20px", color: "rgb(88 2 206)", display: "inline-block" }}>
                                                <FontAwesomeIcon icon={faLocationDot} className={classes.typeIcon} />
                                            </div>
                                            <span style={{ marginLeft: "5px" }} >{i18next.t('profile:list.contactDetails')}</span>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <div>
                                                <div className={styles.section}>
                                                    <span className={styles.sectionTitle}>{i18next.t('profile:tabPanel.address')}</span>
                                                    <span className={styles.sectionData}>{data.fullAddressFrench}</span>
                                                </div>
                                                {data.personalPhone != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.personalPhone')}</span>
                                                        <span className={styles.sectionData}>{data.personalPhone}</span>
                                                    </div>
                                                }
                                                {data.personalCellphone != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.personalCellphone')}</span>
                                                        <span className={styles.sectionData}>{data.personalCellphone}</span>
                                                    </div>
                                                }
                                                {data.personalEmail != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.personalEmail')}</span>
                                                        <span className={styles.sectionData}>{data.personalEmail}</span>
                                                    </div>
                                                }
                                                {data.phoneOffice != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.phoneOffice')}</span>
                                                        <span className={styles.sectionData}>{data.phoneOffice}</span>
                                                    </div>
                                                }
                                                {data.phoneExtension != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.phoneExtension')}</span>
                                                        <span className={styles.sectionData}>{data.phoneExtension}</span>
                                                    </div>
                                                }
                                                {data.corporateCellphone != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.corporateCellphone')}</span>
                                                        <span className={styles.sectionData}>{data.corporateCellphone}</span>
                                                    </div>
                                                }
                                                {data.pager != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.pager')}</span>
                                                        <span className={styles.sectionData}>{data.pager}</span>
                                                    </div>
                                                }
                                                {data.corporateEmail != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.corporateEmail')}</span>
                                                        <span className={styles.sectionData}>{data.corporateEmail}</span>
                                                    </div>
                                                }
                                                {data.language != null &&
                                                    <div className={styles.section}>
                                                        <span className={styles.sectionTitle}>{i18next.t('profile:list.language')}</span>
                                                        <span className={styles.sectionData}>{data.language}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            } />
                        </ListItem>
                    </React.Fragment>

                    {(isDisplaySeniorityDate || isDisplayHiringDate || isDisplayFirstDate || isDisplayLastDate || isDisplayInactiveDate) &&
                        <React.Fragment>
                            <ListItem button className="listItem">
                                <ListItemText disableTypography={true} primary={
                                    <React.Fragment>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <div className={styles.coordinateTitle}>
                                                <div style={{ fontSize: "20px", color: "rgb(97 150 202)", display: "inline-block" }}>
                                                    <FontAwesomeIcon icon={faCalendar} className={classes.typeIcon} />
                                                </div>
                                                <span style={{ marginLeft: "5px" }}>{i18next.t('profile:list.dates')}</span>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <div>
                                                    {isDisplaySeniorityDate && data.seniorityDate != null &&
                                                        <div className={styles.section}>
                                                            <span className={styles.sectionTitle}>{i18next.t('profile:list.seniority')}</span>
                                                            <span className={styles.sectionData}>{new Date(data.seniorityDate).toISOString().split('T')[0]}</span>
                                                        </div>
                                                    }
                                                    {isDisplayHiringDate && data.hiringDate != null &&
                                                        <div className={styles.section}>
                                                            <span className={styles.sectionTitle}>{i18next.t('profile:list.hiring')}</span>
                                                            <span className={styles.sectionData}>{new Date(data.hiringDate).toISOString().split('T')[0]}</span>
                                                        </div>
                                                    }
                                                    {isDisplayFirstDate && data.firstDate != null &&
                                                        <div className={styles.section}>
                                                            <span className={styles.sectionTitle}>{i18next.t('profile:list.firstDay')}</span>
                                                            <span className={styles.sectionData}>{new Date(data.firstDate).toISOString().split('T')[0]}</span>
                                                        </div>
                                                    }
                                                    {isDisplayLastDate && data.lastDate != null &&
                                                        <div className={styles.section}>
                                                            <span className={styles.sectionTitle}>{i18next.t('profile:list.lastDay')}</span>
                                                            <span className={styles.sectionData}>{new Date(data.lastDate).toISOString().split('T')[0]}</span>
                                                        </div>
                                                    }
                                                    {isDisplayInactiveDate && data.inactiveDate != null &&
                                                        <div className={styles.section}>
                                                            <span className={styles.sectionTitle}>{i18next.t('profile:list.terminationDate')}</span>
                                                            <span className={styles.sectionData}>{new Date(data.inactiveDate).toISOString().split('T')[0]}</span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                } />
                            </ListItem>
                        </React.Fragment>
                    }
                </div>
                <Dialog fullScreen open={open} onClose={handleCloseEdit} TransitionComponent={Transition}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseEdit} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {i18next.t("profile:title")}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <div className={styles.rootEditProfile}>
                        <EditProfile isPending={isPending} data={data} dataEmployee={dataEmployee} handleReload={handleReload} />
                    </div>
                </Dialog>
                {storage.getIsProfileConsultationMode() == false && <Fab color="primary" aria-label="edit" className={`addButtonFabWithBar ${isiOS && "addButtonFabWithBarIOS"}`} onClick={() => handleEdit()} >
                    <EditIcon />
                </Fab>}
            </div>
        </LoadingOverlay>
    );
}

export default withNamespaces(['Language', 'profile', 'buttons'], { wait: true })(ProfileList);